<template>
  <div id="login-form">
    <h1 class="ui center aligned header">Select an Authentication Method</h1>
    <template v-for="c in choices">
      <div class="ui divider" :key="`${c.syncguid}-divider`"></div>
      <button
        class="ui large green fluid button"
        @click="$emit('choose', c)"
        :key="`${c.syncguid}-button`"
      >
        {{ c.title }}
      </button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AuthChoices',
  props: ['choices'],
};
</script>

<style lang="less" scoped>
#login-form {
  padding: 2em;
  background-color: #eaeaea;
}
</style>
